<template>
  <div class="event">
    <Progression v-if="loading"></Progression>
    <div v-else-if="canEdit()" class="event-management">
      <v-container fill-height fluid>
        <v-layout align-center justify-center>
          <v-flex sm12 md6>
            <div class="event-tabs">
              <v-btn
                v-for="tab in tabs"
                :key="tab.id"
                :ref="tab.ref"
                :class="['tab-btn', { active: selected === tab }]"
                @click="selected = tab"
              >
                {{ tab.name }}
              </v-btn>
              <component
                :is="selected.component"
                v-bind="selected.props"
                class="tab"
              ></component>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-container v-else fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex sm12 md6>
          <EventDetails :passed-event="event"></EventDetails>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Progression from "@/components/Progression";
import EventDetails from "./EventDetails";
import EventParticipations from "./EventParticipations";
import adaptersIn from "@/services/data-adapter/incoming/scheduler";

export default {
  components: {
    Progression,
    EventDetails
  },

  data: () => ({
    activeTab: 1,
    selected: "",
    loading: true,
    event: null
  }),

  computed: {
    tabs: function() {
      return [
        {
          id: 1,
          name: this.$t("app.buttons.tabs.details"),
          ref: "detailsButton",
          component: EventDetails,
          props: {
            passedEvent: this.event
          }
        },
        {
          id: 2,
          name: this.$t("scheduler.event.participations.title"),
          ref: "participationsButton",
          component: EventParticipations,
          props: {
            editable: !this.event.cancelled
          }
        }
      ];
    }
  },

  watch: {
    loading: function(val) {
      if (!val && this.canEdit()) {
        this.$nextTick(function() {
          this.$refs.detailsButton[0].$emit("click");
        });
      }
    }
  },

  mounted: function() {
    this.$nextTick(function() {
      this.getEvent();
    });
  },

  methods: {
    canEdit() {
      const role = this.$store.getters["site/user"].role;
      return role === "admin" || role === "teacher";
    },

    back() {
      this.$router.go(-1);
    },

    getEvent() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.$http
          .get("/events/" + this.$route.params.eventId + "?trashed=1")
          .then(response => {
            adaptersIn.event(response.data.event).then(res => {
              this.event = res;
              this.loading = false;
              resolve(res);
            });
          })
          .catch(error => {
            if (process.env.NODE_ENV !== "production") {
              console.log(error);
            }
            reject(error);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-btn {
  width: 50%;
  padding: 6px 10px;
  background: #fff;
  cursor: pointer;
  margin-left: 0px;
  margin-right: 0px;
  border: 2px solid #ccc;
  outline: none;
}
.active {
  border-bottom: 3px solid #ed1c24;
  background: #fcfcfc;
}
.tab {
  border: 1px solid #ccc;
  padding: 10px;
}
</style>
